import { render } from "./vipDetails.vue?vue&type=template&id=6409fb3e&scoped=true"
import script from "./vipDetails.vue?vue&type=script&lang=js"
export * from "./vipDetails.vue?vue&type=script&lang=js"

import "./vipDetails.vue?vue&type=style&index=0&id=6409fb3e&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6409fb3e"]])

export default __exports__